import Actions from "./actions";
import GigActions from "../../gig/duck/actions";
import { API_URL } from "../../common/constants";
import axios from "axios";
import protectedAxios from "../../common/axios";
import {
  MODE_PROVIDE,
  NAV_BAR_ITEMS_PROVIDE,
} from "../../gig/common/constants";
import {
  GA_EVENT_LOGIN_CUSTOM,
  GA_EVENT_LOGIN_GOOGLE,
  GA_EVENT_LOGIN_LINKEDIN,
  GA_EVENT_SIGNUP_FACEBOOK,
  GA_EVENT_SIGNUP_GOOGLE,
  GA_EVENT_SIGNUP_LINKEDIN,
} from "./constants";
import Utils from "../../common/utils";
import { userDashboardActions } from "../../user-dashboard/duck";
import {
  getShortListedPrograms,
  getUserPlannerData,
} from "../../common/apis/programFinderShortList.apis";

function loginUser({
  providerName,
  identifier,
  challenge,
  inviteCode,
  role,
  idToken,
  props,
}) {
  const platformInvite = localStorage.getItem("platformInvite");

  return function (dispatch) {
    dispatch(Actions.loginUserRequest(providerName));
    switch (providerName) {
      case "linkedin":
        return axios
          .post(`${API_URL}/v1/auth/linkedin/`, {
            code: challenge,
            inviteCode: inviteCode,
            role,
          })
          .then(({ data: userData }) => {
            dispatch(
              loginUserSuccess(
                userData.accessToken,
                userData.refreshToken,
                userData.profile,
                userData?.isAccountReactivated || false
              )
            );
            if (userData.isNew) {
              // Push event to GA
              window?.dataLayer?.push({
                event: GA_EVENT_SIGNUP_LINKEDIN,
                firstName: userData?.profile?.firstName,
                lastName: userData?.profile?.lastName,
                email: userData?.profile?.email,
              });
            } else {
              window?.dataLayer?.push({
                event: GA_EVENT_LOGIN_LINKEDIN,
                firstName: userData?.profile?.firstName,
                lastName: userData?.profile?.lastName,
                email: userData?.profile?.email,
              });
            }
          })
          .catch((error) => {
            dispatch(
              Actions.loginUserFailure({
                response: {
                  message: error?.data?.message ? error.data.message : null,
                },
              })
            );
          });
      case "google":
        return axios
          .post(`${API_URL}/v1/auth/google/`, {
            code: challenge,
            inviteCode: inviteCode,
            idToken,
            role,
            ...(platformInvite && { platformInvite }),
          })
          .then(({ data: userData }) => {
            dispatch(
              loginUserSuccess(
                userData.accessToken,
                userData.refreshToken,
                userData.profile,
                userData?.isAccountReactivated || false
              )
            );

            if (platformInvite) {
              localStorage.removeItem("platformInvite");
              localStorage.removeItem("platformInviteMetadata");
              dispatch(Actions.setPlatformInvite(null));
            }

            if (userData.isNew) {
              // Push event to GA
              window?.dataLayer?.push({
                event: GA_EVENT_SIGNUP_GOOGLE,
                firstName: userData?.profile?.firstName,
                lastName: userData?.profile?.lastName,
                email: userData?.profile?.email,
              });
            } else {
              window?.dataLayer?.push({
                event: GA_EVENT_LOGIN_GOOGLE,
                firstName: userData?.profile?.firstName,
                lastName: userData?.profile?.lastName,
                email: userData?.profile?.email,
              });
            }
          })
          .catch((error) => {
            dispatch(
              Actions.loginUserFailure({
                response: {
                  message: error?.data?.message ? error.data.message : null,
                },
              })
            );
            dispatch(
              Actions.showLoginModal(true, {
                isLoginDismissible: true,
              })
            );
          });
      case "email":
        return axios
          .post(`${API_URL}/v1/auth/login/`, {
            email: identifier,
            password: challenge,
          })
          .then(({ data: userData }) => {
            //Check if user has avatar if not create one and assign to the user
            if (!userData?.profile?.avatar) {
              axios
                .post(`${API_URL}/v1/game-player/profile/avatar-to-s3`, {
                  gamePlayerId: userData.profile._id,
                  avatar: Utils.generateAvatar(
                    `${userData.profile.firstName} ${userData.profile.lastName}`,
                    userData.profile.email.length
                  ),
                })
                .then((response) => {
                  const res = response.data;
                  userData.profile.avatar = res.avatar;
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            dispatch(
              loginUserSuccess(
                userData.accessToken,
                userData.refreshToken,
                userData.profile,
                userData?.isAccountReactivated || false
              )
            );
            window?.dataLayer?.push({
              event: GA_EVENT_LOGIN_CUSTOM,
              firstName: userData?.profile?.firstName,
              lastName: userData?.profile?.lastName,
              email: userData?.profile?.email,
            });
          })
          .catch((error) => {
            dispatch(
              Actions.loginUserFailure({
                response: {
                  message: error?.data?.message ? error.data.message : null,
                },
              })
            );
          });

      case "facebook":
        const { email } = props;
        return axios
          .post(`${API_URL}/v1/auth/facebook/`, {
            idToken,
            role,
            email,
            inviteCode,
            ...(platformInvite && { platformInvite }),
          })
          .then(({ data: userData }) => {
            dispatch(
              loginUserSuccess(
                userData.accessToken,
                userData.refreshToken,
                userData.profile,
                userData?.isAccountReactivated || false
              )
            );

            if (platformInvite) {
              localStorage.removeItem("platformInvite");
              localStorage.removeItem("platformInviteMetadata");
              dispatch(Actions.setPlatformInvite(null));
            }

            if (userData.isNew) {
              // Push event to GA
              window?.dataLayer?.push({
                event: GA_EVENT_SIGNUP_FACEBOOK,
                firstName: userData?.profile?.firstName,
                lastName: userData?.profile?.lastName,
                email: userData?.profile?.email,
              });
            } else {
              window?.dataLayer?.push({
                event: GA_EVENT_SIGNUP_FACEBOOK,
                firstName: userData?.profile?.firstName,
                lastName: userData?.profile?.lastName,
                email: userData?.profile?.email,
              });
            }
          })
          .catch((error) => {
            dispatch(
              Actions.loginUserFailure({
                response: {
                  message: error?.data?.message ? error.data.message : null,
                },
              })
            );
            dispatch(
              Actions.showLoginModal(true, {
                isLoginDismissible: true,
              })
            );
          });

      default:
        console.debug(
          "Hey, it seems you are trying to login using a provider which is not yet supported."
        );
        break;
    }
  };
}

function loginUserSuccess(
  accessToken,
  refreshToken,
  profile,
  isAccountReactivated = false
) {
  return async (dispatch) => {
    dispatch(
      Actions.loginUserSuccess(
        accessToken,
        refreshToken,
        profile,
        isAccountReactivated
      )
    );
    dispatch(fetchGamePlayerProfile());
    if (profile?._id) {
      dispatch(fetchShortlistedPrograms(profile?._id));
      dispatch(fetchUserPlannerId(profile?._id));
    }
  };
}

function fetchUserPlannerId(gamePlayerId) {
  return function (dispatch) {
    return getUserPlannerData(gamePlayerId).then((data) => {
      if (data) {
        const { plannerId } = data;
        if (plannerId) {
          dispatch(userDashboardActions.setPlannerId(plannerId));
        }
      }
    });
  };
}

function fetchShortlistedPrograms(userId) {
  return function (dispatch) {
    dispatch(userDashboardActions.fetchingShortlist(true));
    return getShortListedPrograms({ userId })
      .then(({ shortListedPrograms }) => {
        if (shortListedPrograms?.length) {
          dispatch(
            userDashboardActions.setShortlistedPrograms(shortListedPrograms)
          );
        }
      })
      .catch((err) => {
        console.log("Unable to fetch game player profile", err?.response);
      })
      .finally(() => {
        dispatch(userDashboardActions.fetchingShortlist(false));
      });
  };
}
function fetchGamePlayerProfile() {
  return function (dispatch) {
    return protectedAxios
      .get(`${API_URL}/v1/game-player/profile`)
      .then(({ data }) => {
        dispatch(Actions.updateProfile(data));
        const sanitizedPath = Utils.trimTrailingSlash(window.location.pathname);
        if (
          data.isApprovedGigProvider &&
          NAV_BAR_ITEMS_PROVIDE.some(({ path }) => sanitizedPath.includes(path))
        ) {
          dispatch(GigActions.setGigMode(MODE_PROVIDE));
        }
      })
      .catch((err) => {
        console.log("Unable to fetch game player profile", err?.response);
      });
  };
}

function updateGamePlayerEmailVerification() {
  return function (dispatch) {
    return protectedAxios
      .get(`${API_URL}/v1/game-player/search`)
      .then(({ data }) => {
        if (data) {
          dispatch(Actions.updateUserEmailVerification(data.isEmailVerified));
        }
      })
      .catch((err) => {
        console.log("Unable to fetch game player", err?.response);
      });
  };
}

/**
 * Fetch current user's gameplayer data and sync with Redux/localStorage
 * This gets fresh gameplayer data from backend using authenticated request
 *
 * Note: state.user.profile stores gameplayers collection data (email, isEmailVerified, etc.)
 *       state.user.gamePlayerProfile stores profiles collection data (education, experience, etc.)
 *
 * Use this after operations that modify gameplayer on backend (e.g., email verification, plan purchase)
 */
function fetchAndSyncCurrentProfile() {
  return async function (dispatch) {
    try {
      // Fetch current gameplayer data using JWT (uses user ID, not email, so works even if email changed)
      const freshGamePlayer = await protectedAxios
        .get(`${API_URL}/v1/game-player/search`)
        .then(({ data }) => data);

      if (!freshGamePlayer) {
        console.warn("No gameplayer data returned");
        return;
      }

      // Update Redux state.user.profile with fresh gameplayer data
      dispatch(Actions.updateProfileKeys(freshGamePlayer));

      // Update localStorage with fresh data to prevent stale data on reload
      const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
      const updatedUserInfo = { ...userInfo, ...freshGamePlayer };
      localStorage.setItem("user", JSON.stringify(updatedUserInfo));

      console.info("Gameplayer data synced successfully");
    } catch (error) {
      console.error("Failed to sync gameplayer data:", error);
      // Don't throw - this is a background sync operation
    }
  };
}
const Operations = {
  loginUser,
  loginUserSuccess,
  fetchGamePlayerProfile,
  updateGamePlayerEmailVerification,
  fetchAndSyncCurrentProfile,
};

export default Operations;
